import * as actionTypes from "../actions/handelData";

const initialState = {
  startDate: "",
  loading: false,
  error: false,
  message: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DATA_START:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        //action
        startDate: action.startDate,
        //
        loading: false,
        error: false,
      };
    case actionTypes.FETCH_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
